import {Card, Pagination, Table} from "antd";
import {renderDate} from "../../../../utils";
import {Button, PopperUserInfo, StatusLabel, Image, FontAwesomeIcon} from "../../../../components";
import HostInfoAction from "./HostInfoAction";
import {useState} from "react";
import Paragraph from "antd/es/typography/Paragraph";

function HostInfoTable({items = [], pagination, onPaginationChange, can, setItemEdit, handleStatus, openModal, onHandleLoginHost, onHandleLoginDb, onHandleFtpCreated})
{
    const [ftpAccounts, setFtpAccounts] = useState({});

    const onLoginHost = async (item, setLoginHostLoading) => {
        setLoginHostLoading(true);
        await onHandleLoginHost(item);
        setLoginHostLoading(false);
    }

    const onLoginDb = async (item, setLoginDbLoading) => {
        setLoginDbLoading(true);
        await onHandleLoginDb(item);
        setLoginDbLoading(false);
    }

    const onFtpCreated = async (item, setLoginFtpLoading) => {
        setLoginFtpLoading(true);
        const res = await onHandleFtpCreated(item)
        setFtpAccounts(prev => ({
            ...prev,
            [item.id]: res
        }));
        setLoginFtpLoading(false);
    }

    const FtpRender = ({ftpAccount}) => {
        return (<Card>
            <p>Ftp account: <Paragraph copyable>{ftpAccount.user}</Paragraph></p>
            <p>Ftp password: <Paragraph copyable>{ftpAccount.pass}</Paragraph></p>
        </Card>)
    }

    const FtpColumn = ({item}) => {

        const [loginFtpLoading, setLoginFtpLoading] = useState(false);

        if(item.ftpName === '' || item.ftpName === undefined)
        {
            return <Button
                loading={loginFtpLoading}
                background
                green
                leftIcon={<FontAwesomeIcon icon={'fa-light fa-cloud-plus'} />}
                onClick={() => onFtpCreated(item, setLoginFtpLoading)}>Tạo FTP</Button>
        }

        if(ftpAccounts[item.id]?.user && ftpAccounts[item.id]?.pass)
        {
            return <FtpRender ftpAccount={ftpAccounts[item.id]} />
        }

        return <p>
            <Paragraph copyable>{item.ftpName}</Paragraph>
            <Button
                loading={loginFtpLoading}
                small
                background
                green
                leftIcon={<FontAwesomeIcon icon={'fa-light fa-arrows-rotate'}/>}
                onClick={() => onFtpCreated(item, setLoginFtpLoading)}>Tạo lại</Button></p>;
    }

    const LoginDAColumn = ({item}) =>
    {
        const [loginHostLoading, setLoginHostLoading] = useState(false);

        return (item.status.key === 'confirm') && <Button
            loading={loginHostLoading}
            background
            blue
            leftIcon={<FontAwesomeIcon icon={'fa-light fa-server'}/>}
            onClick={() => onLoginHost(item, setLoginHostLoading)}>Đăng nhập host</Button>
    }

    const LoginDbColumn = ({item}) =>
    {
        const [loginDbLoading, setLoginDbLoading] = useState(false);

        return (item.status.key === 'confirm') && <Button
            loading={loginDbLoading}
            background
            blue
            leftIcon={<FontAwesomeIcon icon={'fa-light fa-database'} />}
            onClick={() => onLoginDb(item, setLoginDbLoading)}>phpmyadmin</Button>
    }

    const columns = [
        { title: 'Nhân viên', dataIndex: 'user', key: "user", width: '150px', render: (_, item) => (
                item.user?.id &&
                <PopperUserInfo user={item.user}>
                    <div className="d-flex gap align-items">
                        <div className="avatar"><Image src={item.user?.avatar} /></div>
                        <div>
                            <b>{item.user?.lastname}</b>
                            <p>{item.user?.username}</p>
                        </div>
                    </div>
                </PopperUserInfo>
            )},
        {
            title: "Tên miền",
            dataIndex: "domain",
            key: "domain",
            width: 250,
            render: (_, item) => {
                return (<span>{item.domain}</span>)
            }
        },
        {
            title: "Ip",
            dataIndex: "Ip",
            key: "Ip",
            render: (_, item) => {
                return (<span>{item.hostIp}</span>)
            }
        },
        {
            title: "Host",
            dataIndex: "host",
            key: "host",
            render: (_, item) => {
                return (<span>{item.hostName}</span>)
            }
        },
        {
            title: "Login DA",
            dataIndex: "loginDA",
            key: "loginDA",
            width: 200,
            render: (_, item) => {
                return <LoginDAColumn item={item} />
            }
        },
        {
            title: "Login Phpmyadmin",
            dataIndex: "loginPhpmyadmin",
            key: "loginPhpmyadmin",
            width: 200,
            render: (_, item) => {
                return <LoginDbColumn item={item} />
            }
        },
        {
            title: "FTP",
            dataIndex: "ftp",
            key: "ftp",
            width: 230,
            render: (_, item) => {
                return <FtpColumn item={item} />
            }
        },
        {
            title: "Ngày tạo",
            dataIndex: "created",
            key: "created",
            render: (_, item) => {
                return <span>{renderDate(item.created)}</span>;
            }
        },
        {
            title: "Tình trạng",
            dataIndex: "status",
            key: "status",
            width: 150,
            render: (_, item) => {
                return <span><StatusLabel type={item.status.badge}>{item.status.label}</StatusLabel></span>;
            }
        },
        {
            title: '#',
            dataIndex: 'action',
            key: "action",
            width: '220px',
            render: (_, item) => {
                return <HostInfoAction
                    item={item}
                    can={can}
                    handleStatus={handleStatus}
                    openModal={openModal}
                    setItemEdit={setItemEdit}
                />
            }
        }
    ]

    const dataSource= items.map(row => ({
        key: row.id, // I added this line
        ...row
    }));

    return (
        <div className="table-wrapper">
            <div className="table-box">
                <Table columns={columns} dataSource={dataSource} scroll={{ y:550 }} pagination={false} />
            </div>
            <Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
        </div>
    )
}

export default HostInfoTable;